import api from 'modules/api';

export const updateCustomFieldsUserRequest = (payload) => {
  return api.post(`/custom-fields-answers`, { params: payload });
};
